<template>
  <CommonParagraph title="Note NPS moyenne">
    <LayoutCard class="average-card">
      <CommonStatChip size="large" transparent color="success">
        {{ formatAverageScore(average) }}
      </CommonStatChip>
      <RouterLink :to="{ name: 'extranet-nps-stats' }">Voir toutes les notes NPS</RouterLink>
    </LayoutCard>
  </CommonParagraph>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
import CommonParagraph from '@/components/common/CommonParagraph.vue'
import CommonStatChip from '@/components/common/CommonStatChip.vue'
import LayoutCard from '@/components/layout/LayoutCard.vue'
import { formatAverageScore } from '@/services/service_nps'

defineProps<{
  average: number | null
}>()
</script>

<style scoped lang="scss">
.average-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.average-card a {
  color: var(--vc-dark);
  opacity: 75%;
  text-decoration: underline;
  text-align: center;
}
</style>
